var { evaluateFormula } = require('../../../../libs/formulaSandbox');

function feedsAnimationSpeed(minValue, maxValue, formula, pointValues, strokeDashArray, speedScalingAlpha = 2, alpha = 1.4) {
  var result = 0;

  try {
    // Ensure function is well-formed
    const testFunc = new Function(`return (${formula})`)();

    // **Execute the function inside the sandbox**
    result = evaluateFormula(formula, pointValues || []);

    // Define speed range
    const baseDashLength = 10; // Reference: [5,5]
    const baseFastestSpeed = 150;
    const baseSlowestSpeed = 1000;

    const dashLength = Array.isArray(strokeDashArray)
    ? strokeDashArray.reduce((sum, val) => sum + val, 0)
    : baseDashLength;

    // Adjust speed range based on dashLength
    const dashScale = Math.pow(dashLength / baseDashLength, speedScalingAlpha);
    const fastestSpeed = Math.round(baseFastestSpeed * dashScale);
    const slowestSpeed = Math.round(baseSlowestSpeed * dashScale);

    // Ensure result is within range
    if (result <= minValue) {
      return 0;
    }
    if (result >= maxValue) {
      return fastestSpeed;
    }
 
    // Adjust based on strokeDashArray


    const normalized = (result - minValue) / (maxValue - minValue);
    const speed = slowestSpeed - normalized * (slowestSpeed - fastestSpeed);

    const scaleFactor = Math.pow(dashLength / baseDashLength, alpha);
    const adjustedSpeed = Math.round(speed * scaleFactor);

    return adjustedSpeed;

  } catch (err) {
    console.log(err)
  }
}



module.exports = feedsAnimationSpeed;
